module.exports = __webpack_public_path__ + "img/no-data-100.37a14712.png";